<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
export default {
  data() {
    return {};
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <!--end footer-->
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-end">
          <div class="col-sm-6">
            <div class="text-sm-left">
              <p class="goldman-tf mb-2" style="font-size: 20px !important;">
                MAGNIFICENT CAPITAL
              </p>
              <p class="opensans-tf footer-p-text" style="text-transform: uppercase; font-weight: light !Important; font-size: 12px !Important;">1270 Avenue of the Americas</p>
              <p class="opensans-tf footer-p-text" style="text-transform: uppercase; font-weight: light !Important; font-size: 12px !Important;">7th Floor</p>
              <p class="opensans-tf footer-p-text" style="text-transform: uppercase; font-weight: light !Important; font-size: 12px !Important;">New York, NY 10020</p>
            </div>
          </div>
          <!--end col-->

          <div class="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0 align-bottom text-right">
                <p class="footer-p-text align-center mt-2 mb-1">© 2020 - {{ new Date().getFullYear() }} Magnificent Capital LLC</p>
                <p class="footer-p-text align-center mt-1">ALL RIGHTS RESERVED WORLDWIDE</p>

          </div>
          <!--end col-->
        </div>
        <hr style="border-top: 1px solid rgba(0,0,128,0.17);"/>
        <!--end row-->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-6 mt-4 mt-sm-0 pt-4 pt-sm-4  text-left">
                <a class="footer-p-text" href="javascript:void(0)"
                  ><span style="color: #adb5bd;">SEC Funding Portal:</span> #007-00359</a>
          </div>
        <div class="col-lg-6 col-md-6 col-6 mt-4 mt-sm-0 pt-2 pt-sm-0 px-0">
          <ul class="list-group list-group-horizontal footer-list mt-4 float-right footer-p-text">
            <li class="list-group-item border-0">
              <router-link to="/page-aboutus" class="text-foot"
                >About us</router-link
              >
            </li>
            <li class="list-group-item border-0">
              <router-link to="/cookie-policy" class="text-foot"
                >Cookie Policy</router-link
              >
            </li>
            <li class="list-group-item border-0">
              <router-link to="/privacy-policy" class="text-foot"
                >Privacy Policy</router-link
              >
            </li>
            <li class="list-group-item border-0">
              <router-link to="/terms-and-conditions" class="text-foot"
                >
                Terms of Use</router-link
              >
            </li>
          </ul>
        </div>
        </div>
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
  </div>
</template>
<style>
.list-group-item{
  background-color: transparent !important;
}
</style>
